@defer (when paypalBannerConf.enabled) {
<div
  data-pp-message
  class="{{ position === 'cart' ? 'cart' : '' }}"
  [attr.data-pp-buyerCountry]="activeLanguage"
  [attr.data-pp-placement]="position"
  [attr.data-pp-amount]="price?.value"
  [attr.data-pp-style-text-align]="textAlign"
></div>
}
